import { render, staticRenderFns } from "./CardRuleCard.vue?vue&type=template&id=54b95586&"
import script from "./CardRuleCard.vue?vue&type=script&lang=ts&"
export * from "./CardRuleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports